import { FilterSectionType, IFilter, IFilterSection, IOption } from '@shared/filters/filter.util';

export const normalizeRestoredContentHubFilter = (
  filter: IFilterSection,
  filterConfigs: IFilter[],
): IFilterSection => {
  if (filter.propertyName !== 'date') {
    return filter;
  }

  const currentFilterSection: IFilterSection | undefined = getCurrentDateFilterSection(filter, filterConfigs);
  if (!currentFilterSection) {
    return filter;
  }

  return {
    ...filter,
    options: currentFilterSection.options || filter.options,
    dateConfig: currentFilterSection.dateConfig || filter.dateConfig,
    preSelectedValue: normalizeRestoredDateValue(filter.preSelectedValue, currentFilterSection),
  };
};

const getCurrentDateFilterSection = (
  filter: IFilterSection,
  filterConfigs: IFilter[],
): IFilterSection | undefined => {
  const currentSections: IFilterSection[] = filterConfigs.reduce(
    (sections: IFilterSection[], config: IFilter): IFilterSection[] => [
      ...sections,
      ...config.sections,
    ],
    []
  );

  return currentSections.find((section: IFilterSection): boolean =>
    section.propertyName === filter.propertyName &&
    section.filterType === filter.filterType
  );
};

const normalizeRestoredDateValue = (preSelectedValue: any, currentFilterSection: IFilterSection): any => {
  if (currentFilterSection.filterType !== FilterSectionType.SELECT_DROPDOWN) {
    return preSelectedValue;
  }

  const currentOptions: IOption[] = currentFilterSection.options || [];
  const normalizeDateOption = (selectedOption: IOption): IOption =>
    currentOptions.find((option: IOption): boolean =>
      !!selectedOption?.key && option.key === selectedOption.key
    ) ||
    currentOptions.find((option: IOption): boolean => option.title === selectedOption?.title) ||
    selectedOption;

  return Array.isArray(preSelectedValue)
    ? preSelectedValue.map((selectedOption: IOption): IOption => normalizeDateOption(selectedOption))
    : normalizeDateOption(preSelectedValue);
};

export const normalizeContentHubDateParam = (date: string): string => {
  if (!date || date === '-1') {
    return date;
  }

  return date.slice(0, 10);
};
